import React from "react";
import { useNavigate } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";
import CommonPopup from "..";
import CommonButton from "../../Button";

type Props = { popup?: string; onClose?: () => void };

export default function NeedCertCompanyPopup({ popup, onClose }: Props) {
  const navigate = useNavigate();
  const [user] = useUserContext();

  const getCertString = () => {
    if (user.companyId) {
      return "회사 인증";
    } else {
      return "회사 설정";
    }
  };

  return (
    <CommonPopup
      title={`${getCertString()} 안내`}
      isOpen={popup === "needCertCompany"}
      padding={0}
      onClose={onClose}
    >
      <div className="px-5 pt-0 pb-[30px]">
        <div className="py-2.5 flex flex-col items-center text-center">
          <NeedCertCompanyPopupIcon />
          <div className="text-sm text-brand-neutral-60">
            {getCertString()}을 통해​
            <br />
            <span className="text-brand-primary-magenta">
              다양한 샌디 서비스를 누려보세요​
            </span>
          </div>
        </div>
      </div>
      <CommonButton
        className=" h-bottom-button w-full rounded-none"
        onClick={() =>
          user.companyId
            ? navigate("/myinfo/cert/company")
            : navigate("/myinfo", { state: { popup: "changeCompany" } })
        }
      >
        {`${getCertString()}하기`}
      </CommonButton>
    </CommonPopup>
  );
}

export const NeedCertCompanyPopupIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.5754 13.4734V17.4834"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M39.6205 15.4783H35.5305"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.7145 19.2426C31.7145 21.6841 29.735 23.6623 27.2948 23.6623C24.8533 23.6623 22.8738 21.6841 22.8738 19.2426C22.8738 16.8011 24.8533 14.8229 27.2948 14.8229C29.735 14.8229 31.7145 16.8011 31.7145 19.2426Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M27.3288 26.8918C30.5851 26.8834 33.3539 28.3786 34.3717 31.5971C32.3203 32.8476 29.9057 33.3293 27.3288 33.323C24.7519 33.3293 22.3373 32.8476 20.2859 31.5971C21.3048 28.3751 24.0689 26.8834 27.3288 26.8918Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <rect
      x="10.0107"
      y="7.55945"
      width="34.9636"
      height="39.8051"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M45.1297 12.6354H49.9893V52.4404H15.0256V48.0021"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M23.1399 39.626H31.8451"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);
